import { HttpClient, HttpHeaders, HttpParams, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { List, Redirect, Reply, UpdateAddress } from './inbox.interface';
import { Subject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class InboxService {
    private token!: string;
    private httpOptions: any;

    private basePath = environment.interop.basePath;
    private listUrl = this.basePath + environment.interop.indoc.inbox.list;
    private findUrl = this.basePath + environment.interop.indoc.inbox.find;
    private preluareUrl = this.basePath + environment.interop.indoc.inbox.preluare;
    private nepreluareUrl = this.basePath + environment.interop.indoc.inbox.nepreluare;
    private updateAddressUrl = this.basePath + environment.interop.indoc.inbox.updateAddress;
    private replyUrl = this.basePath + environment.interop.indoc.inbox.reply;
    private redirectUrl = this.basePath + environment.interop.indoc.inbox.redirect;
    private favoriteUrl = this.basePath + environment.interop.indoc.inbox.favorite;
    private deleteUrl = this.basePath + environment.interop.indoc.inbox.delete;
    public downloadUrl = this.basePath + environment.interop.indoc.inbox.downloadFile;
    public printUrl = this.basePath + environment.interop.indoc.inbox.print;
    public printFileUrl = this.basePath + environment.interop.indoc.inbox.printFile;
    private processFileUrl = this.basePath + environment.interop.indoc.inbox.processFile;
    private processFileAllUrl = this.basePath + environment.interop.indoc.inbox.processFileAll;
    public printEmailsUrl = this.basePath + environment.interop.indoc.inbox.printEmails;
    public printEmailThreadUrl = this.basePath + environment.interop.indoc.inbox.printEmailThread;

    private sablonContent = new Subject<string>();
    sablonContent$ = this.sablonContent.asObservable();

    constructor(private http: HttpClient) { }

    list(payload: List) {
        return this.http.post(this.listUrl, payload, this.httpOptions);
    }

    find(id: number) {
        return this.http.get(this.findUrl + id, this.httpOptions);
    }

    preluare(id: number) {
        return this.http.get(this.preluareUrl + id, this.httpOptions);
    }

    nepreluare(id: number) {
        return this.http.get(this.nepreluareUrl + id, this.httpOptions);
    }

    updateAddress(id: number, payload: UpdateAddress) {
        return this.http.post(this.updateAddressUrl + id, payload, this.httpOptions);
    }

    reply(payload: Reply) {
        return this.http.post(this.replyUrl, payload, this.httpOptions);
    }

    redirect(payload: Redirect) {
        return this.http.post(this.redirectUrl, payload, this.httpOptions);
    }

    favorite(id: number) {
        return this.http.get(this.favoriteUrl + id, this.httpOptions);
    }

    delete(id: number) {
        return this.http.delete(this.deleteUrl + id, this.httpOptions);
    }

    sendContent(content: string) {
        this.sablonContent.next(content);
    }

    processFile(id: number) {
        return this.http.get(this.processFileUrl + id, this.httpOptions);
    }

    processFileAll(id: number) {
        return this.http.get(this.processFileAllUrl + id, this.httpOptions);
    }

    setToken(token: string) {
        this.token = token;
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: `Bearer ${this.token}`,
            }),
        };
    }
}
